var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKnetIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_419_14948)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 24H0V0H27V24Z",
    stroke: "#E5E7EB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.55556 3C3.14601 3 2 4.15313 2 5.57143V6.85714H25V5.57143C25 4.15313 23.854 3 22.4444 3H4.55556ZM25 10.7143H2V18.4286C2 19.8469 3.14601 21 4.55556 21H22.4444C23.854 21 25 19.8469 25 18.4286V10.7143ZM6.47222 15.8571H9.02778C9.37917 15.8571 9.66667 16.1464 9.66667 16.5C9.66667 16.8536 9.37917 17.1429 9.02778 17.1429H6.47222C6.12083 17.1429 5.83333 16.8536 5.83333 16.5C5.83333 16.1464 6.12083 15.8571 6.47222 15.8571ZM10.9444 16.5C10.9444 16.1464 11.2319 15.8571 11.5833 15.8571H16.6944C17.0458 15.8571 17.3333 16.1464 17.3333 16.5C17.3333 16.8536 17.0458 17.1429 16.6944 17.1429H11.5833C11.2319 17.1429 10.9444 16.8536 10.9444 16.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_419_14948"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnetIcon);
export default __webpack_public_path__ + "static/media/knet-icon.3dfe14f7da40edd9807369765f6e695b.svg";
export { ForwardRef as ReactComponent };